module.exports = __webpack_public_path__ + "img/in-progress.80be7bda.png";